import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconGlobe: React.FC<Props> = ({
  width = 16,
  height = 16,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99992 0.833374C4.04792 0.833374 0.833252 4.04871 0.833252 8.00004C0.833252 11.9514 4.04792 15.1667 7.99992 15.1667C11.9519 15.1667 15.1666 11.9514 15.1666 8.00004C15.1666 4.04871 11.9519 0.833374 7.99992 0.833374ZM14.1413 7.50004H11.4412C11.3539 5.67137 10.7912 3.80805 9.81791 2.10738C12.1799 2.83805 13.9353 4.95337 14.1413 7.50004ZM8.48659 1.85803C9.65726 3.5987 10.3392 5.57337 10.4412 7.50004H5.55859C5.65993 5.57337 6.34258 3.5987 7.51324 1.85803C7.67458 1.84537 7.83592 1.83337 7.99992 1.83337C8.16392 1.83337 8.32593 1.84537 8.48659 1.85803ZM6.18193 2.10738C5.20859 3.80805 4.64593 5.67137 4.55859 7.50004H1.85858C2.06458 4.95337 3.81993 2.83805 6.18193 2.10738ZM1.85858 8.50004H4.55859C4.64593 10.3287 5.20859 12.192 6.18193 13.8927C3.81993 13.162 2.06458 11.0467 1.85858 8.50004ZM7.51324 14.142C6.34258 12.4014 5.66059 10.4267 5.55859 8.50004H10.4412C10.3399 10.4267 9.65726 12.4014 8.48659 14.142C8.32526 14.1547 8.16392 14.1667 7.99992 14.1667C7.83592 14.1667 7.67391 14.1547 7.51324 14.142ZM9.81791 13.8927C10.7912 12.192 11.3539 10.3287 11.4412 8.50004H14.1413C13.9353 11.0467 12.1799 13.162 9.81791 13.8927Z"
      fill={color}
    />
  </svg>
);

export default IconGlobe;
